// import Footer from './Footer';
import Header from './Header';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { ImpersonationBanner } from '@/components/auth/ImpersonationBanner';
import SubscriptionBanner from '@/components/feedback/SubscriptionBanner';

const DefaultLayout = () => {
    return (
        <main className="md:grid md:grid-cols-[auto_minmax(0,1fr)] min-h-screen font-cairo">
            <Sidebar />
            <div className="relative flex min-h-screen min-w-0 w-full flex-col">
                <Header />
                <ImpersonationBanner />
                <SubscriptionBanner />
                <div className="mx-auto w-full min-w-0 max-w-full flex-grow px-5 lg:px-8 custom:max-w-[1200px] custom:px-0">
                    <Outlet />
                </div>
                {/* <Footer /> */}
            </div>
        </main>
    );
};

export default DefaultLayout;
